import {
  MdArchitecture, MdDescription, MdChangeCircle, MdGavel, MdPriorityHigh,
  MdRateReview, MdCheckCircleOutline, MdForum, MdLabelOutline,
} from 'react-icons/md';

// Icon + màu cho từng tag của topic. Danh sách toàn chữ viết tắt (PPD, PIF,
// CO…) nên khi liếc nhanh rất khó phân biệt — icon làm việc đó thay.
//
// Để riêng khỏi TopicForm: card danh sách cũng cần bảng này, mà import từ
// TopicForm sẽ kéo theo cả TinyMCE vào bundle của card.
const TAG_META = {
  PPD:        { Icon: MdArchitecture,       color: '#7c3aed' },
  PIF:        { Icon: MdDescription,        color: '#0891b2' },
  CO:         { Icon: MdChangeCircle,       color: '#ea580c' },
  Waiver:     { Icon: MdGavel,              color: '#b45309' },
  Urgent:     { Icon: MdPriorityHigh,       color: '#dc2626' },
  Review:     { Icon: MdRateReview,         color: '#2563eb' },
  Approval:   { Icon: MdCheckCircleOutline, color: '#059669' },
  Discussion: { Icon: MdForum,              color: '#475569' },
};

const DEFAULT_TAG_META = { Icon: MdLabelOutline, color: '#64748b' };

// Tag tự gõ (creatable) không có trong bảng vẫn nhận được icon mặc định.
export const tagMeta = (tag) => TAG_META[tag] || DEFAULT_TAG_META;

export const TAG_NAMES = Object.keys(TAG_META);

export default tagMeta;
